// extracted by mini-css-extract-plugin
export default {"pullSharkLink":"PullSharkBadgeLink_pullSharkLink__+tdNC"};